import { SelectItem } from "../../common/interfaces/common.interface";

export const sortRoadMapList: SelectItem[] = [
  { name: "date", value: "date" },
  { name: "family", value: "family" }

];